<template>
  <div>
    <div class="gap-4">
      <div></div>

      <div class="flex gap-2 items-center mt-2 mb-4">
        <button
          type="button"
          class="flex cursor-pointer items-center justify-center w-8 h-8 rounded-full bg-transparent text-[var(--p-primary-color)] flex-shrink-0 transition hover:opacity-60"
          @click="$emit('back')"
        >
          <IconBack class="w-5 h-5" />
        </button>
        <label
          v-if="title"
          class="montserrat flex items-center text-md font-semibold text-[var(--p-primary-color)] dark:text-[var(--p-text-color)]"
        >
          {{ title }}
        </label>
      </div>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import IconBack from '@/assets/svg/back_icon.svg?component'

interface Props {
  step: number
  title?: string
}

defineProps<Props>()

defineEmits<{
  back: []
}>()
</script>
